import { createSlice } from "@reduxjs/toolkit";
import { getAuditTrialOverview } from "../../api/postCall/getAuditTrialOverview";
import { AuditTrialOverviewResponseModel } from "../../data-model/eventsModal";

export interface AuditTrialOverviewState {
  auditTrialOverview?: AuditTrialOverviewResponseModel;
  isLoading: boolean;
  error?: string;
}

const initialState: AuditTrialOverviewState = {
  auditTrialOverview: undefined,
  isLoading: false,
  error: undefined,
};

const auditTrialOverviewSlice = createSlice({
  name: "auditTrialOverview",
  initialState,
  reducers: {
    setAuditTrialOverview: (state, action) => {
      state.auditTrialOverview = action.payload;
      state.isLoading = false;
      state.error = undefined;
    },
    setIsFetching: (state) => {
      state.isLoading = true;
      state.error = undefined;
      state.auditTrialOverview = undefined;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.auditTrialOverview = undefined;
    },

    resetAuditTrialOverview: (state) => {
      state.auditTrialOverview = undefined;
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const {
  setAuditTrialOverview,
  setIsFetching,
  setError,
  resetAuditTrialOverview,
} = auditTrialOverviewSlice.actions;

export const fetchAuditTrialOverview =
  (orderId: string) => async (dispatch, getState) => {
    const state = getState();
    if (state.auditTrialOverview.isLoading) return;

    dispatch(setIsFetching());
    try {
      const response = await getAuditTrialOverview({ order_id: orderId });
      dispatch(setAuditTrialOverview(response));
    } catch (error) {
      dispatch(setError(error as string));
    }
  };

export default auditTrialOverviewSlice.reducer;
